import { render, staticRenderFns } from "./successPay_view.vue?vue&type=template&id=35590686&scoped=true&"
import script from "./successPay_view.vue?vue&type=script&lang=js&"
export * from "./successPay_view.vue?vue&type=script&lang=js&"
import style0 from "./successPay_view.vue?vue&type=style&index=0&id=35590686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35590686",
  null
  
)

export default component.exports